document.addEventListener('rebuy:reorderLandingPage.ready', function (event) {
    console.log('Reorder ready event');
    var addToCartCount = 0;
    const items = Rebuy.ReorderLandingPage.products;
    var itemCount = Rebuy.ReorderLandingPage.products.length;
    var availableItemCount = 0;
    items.forEach((item, index) => {
        if (item.tags.includes('temp-pos-only') || item.tags.includes('Unavailable') || item.published_at == null) {
        } else {
            availableItemCount = availableItemCount + 1;
        }
    });
    // console.log('Available item count: ' + availableItemCount)

    document.addEventListener('rebuy:cart.add', function (event) {
        setTimeout(() => {
            function enrichProductJSON(products) {
                for (var i = 0; i < products.length; i++) {
                    updateProductJSON(products[i]);
                }

                function updateProductJSON(product) {
                    // MR - Rebuy - 3-3-23: Add product.handle check
                    if (!product.handle) {
                        console.log('No product handle', product);
                        return;
                    }

                    fetch(`/products/${product.handle}.js`)
                        .then((res) => res.json())
                        .then((data) => {
                            Rebuy.Cart.cart.items.forEach((item) => {
                                data.variants.forEach((variant) => {
                                    if (item.id === variant.id && !variant.available) {
                                        Rebuy.Cart.removeItem(item);
                                    }
                                });
                            });
                        })
                        .catch((e) => console.log(e));
                }
            }

            enrichProductJSON(Rebuy.Cart.cart.items);
        }, 3000);

        // console.log('Available item count: ' + availableItemCount)
        addToCartCount++;
        console.log(addToCartCount + ' rebuy cart add occurred - waiting .5 seconds...');
        // setTimeout(() => {
        //     Rebuy.Cart.fetchCart();
        //     console.log('ran rebuy fetchCart');
        // }, '500');
        // if (addToCartCount == availableItemCount) {
        //     console.log('all items added?');
        //     setTimeout(() => {
        //         console.log('checking for missing items...');
        //         var itemButtons = document.querySelectorAll(
        //             '.rebuy-reorder-previous .rebuy-reorder__action-container .rebuy-button:not(.bis-subscribe)'
        //         );
        //         for (i = 0; i < itemButtons.length; ++i) {
        //             if (itemButtons[i].innerText == 'Add to Cart') {
        //                 console.log(
        //                     'CAUGHT A MISSING ITEM - TRYING TO FORCE ADD!'
        //                 );
        //                 // itemButtons[i].click();
        //             }
        //         }
        //     }, '1000');
        // }
    });

    setTimeout(() => {
        console.log('item count: ' + itemCount);
        // Rebuy.Cart.fetchCart()
        const itemElements = document.querySelectorAll('.rebuy-reorder-previous-item');
        // const reorderEmail = event.detail.data.customer.email
        const reorderEmail = 'jesse@clearmarble.net';
        console.log('email: ' + event.detail.data.customer.email);
        items.forEach((item, index) => {
            console.log(item);
            if (item.tags.includes('temp-pos-only') || item.tags.includes('Unavailable') || item.published_at == null) {
                console.log(item.title + ' is out of stock');
                const btn = itemElements[index].querySelector('.rebuy-button');
                if (btn == null) {
                    return;
                }
                btn.disabled = true;
                btn.textContent = 'Sold Out';
                // btn.style.display = 'none'
                btn.style.marginBottom = '10px';
                const BISbutton = document.createElement('button');
                BISbutton.innerText = 'Notify When Available';
                BISbutton.className = 'rebuy-button outline bis-subscribe';
                BISbutton.dataset.empi = item.id;
                BISbutton.dataset.epi = item.variants[0].id;
                BISbutton.dataset.iu = item.image.src;
                BISbutton.dataset.pr = item.variants[0].price;
                BISbutton.addEventListener('click', function (e) {
                    event.preventDefault;
                    event.stopPropagation;
                    console.log('NOTFICATION SUBMIT!');
                    let bisRequestEmail = reorderEmail;
                    // let bisSelector = document.getElementById('bis-selector')
                    let bisVarId = e.target.getAttribute('data-epi');
                    let bisParentId = e.target.getAttribute('data-empi');
                    let bisProductImgUrl = e.target.getAttribute('data-iu');
                    let bisVarPrice = e.target.getAttribute('data-pr');
                    console.log(bisRequestEmail);
                    console.log(bisVarId);
                    console.log(bisParentId);
                    console.log(bisProductImgUrl);
                    console.log(bisVarPrice);
                    if (!bisRequestEmail.length > 0) {
                        // document.getElementById('bis-email-address').classList.add('has-error');
                        alert('Please enter a valid email address!');
                        return false;
                    } else {
                        // document.getElementById('bis-email-address').classList.remove('has-error');
                        window._swat.sendWatchlist(
                            bisRequestEmail,
                            'email',
                            {
                                epi: bisVarId,
                                empi: bisParentId,
                                iu: bisProductImgUrl,
                                pr: bisVarPrice,
                            },
                            function (r) {
                                console.log(r);
                            },
                            function (e) {
                                console.log(e);
                            },
                            0
                        );
                        e.target.innerText = 'Notification Subscribed';
                        e.target.disabled = true;
                    }

                    return false;
                });
                btn.parentNode.appendChild(BISbutton);
            }
        }); //endforeach
        const clearCartButton = document.createElement('button');
        clearCartButton.innerText = 'Clear Cart';
        clearCartButton.className = 'rebuy-button outline clear-cart';
        clearCartButton.id = 'clear-cart';
        clearCartButton.addEventListener('click', function (e) {
            if (confirm('Are you sure you want to remove everything from your cart?') == true) {
                jQuery.post(window.Shopify.routes.root + 'cart/clear.js', function (data) {
                    alert('Cart cleared!');
                    Rebuy.Cart.fetchCart();
                });
            }
        });
        const rebuyCartEl = document.querySelector('.rebuy-reorder-cart');
        rebuyCartEl.append(clearCartButton);
    }, 100);

    // const mutationObserver = new MutationObserver(function (mutations) {
    //     mutations.forEach(function (mutation) {
    //         if (mutation.addedNodes.length) {
    //             console.log('Added', mutation.addedNodes[0]);
    //         }
    //         if (mutation.removedNodes.length) {
    //             console.log('Removed', mutation.removedNodes[0]);
    //         }
    //     });
    // });
    // const rebuyReorderCart = document.querySelector(
    //     '.rebuy-reorder-cart-items'
    // );
    // mutationObserver.observe(rebuyReorderCart, {
    //     childList: true,
    // });

    // setTimeout(() => {
    //     console.log('initial fetchCart force');
    //     Rebuy.Cart.fetchCart();
    // }, '2000');

    // setTimeout(() => {
    //     console.log('secondary fetchCart force');
    //     Rebuy.Cart.fetchCart();
    // }, '5000');

    // setTimeout(() => {
    //     console.log('last fetchCart force');
    //     Rebuy.Cart.fetchCart();
    // }, '8000');
});
